import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import GoldSeam from "@/components/GoldSeam";
import { TestimonialCard } from "@/components/TestimonialCard";
import { TESTIMONIALS } from "@/data/testimonials";

export default function Testimonials() {
  const [lead, ...rest] = TESTIMONIALS;

  return (
    <section id="testimonials" className="relative py-24 md:py-36 bg-paper" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
            <div>
              <p className="eyebrow mb-6">In their words</p>
              <h2
                className="font-display text-ink font-medium leading-[1.1] text-4xl sm:text-5xl"
                data-testid="testimonials-heading"
              >
                What people say afterwards
              </h2>
            </div>
            <p className="text-inkdim text-sm max-w-xs leading-relaxed">
              Names are kept to initials, as this work usually requires. Shared with permission.
            </p>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-5">
          <Reveal className="lg:col-span-5">
            <TestimonialCard t={lead} large />
          </Reveal>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {rest.map((t, i) => (
              <Reveal key={t.id} delay={0.06 * (i + 1)}>
                <TestimonialCard t={t} />
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.12}>
          <div className="mt-14 flex flex-wrap items-center gap-7">
            <Link
              to="/booking"
              data-testid="testimonials-book-session-link"
              className="bg-deep text-canvas text-xs uppercase tracking-[0.24em] font-semibold px-9 py-4 hover:bg-gold transition-colors duration-300"
            >
              Book a Session
            </Link>
            <GoldSeam variant="horizontal" className="w-48 h-10 opacity-70" delay={0.2} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
